export enum RiskItemInformations {
  Nature_Occupation = 'NATURE_OCCU',
  Objet_Valeur_Global = 'OBJ_VAL_GLOB',
  Nbr_Coloc = 'NBR_COLOC',
  Address = 'ADR_RISQUE',
  Code_postal = 'ADR_CODE_POSTAL',
  Ville = 'ADR_VILLE',
  Nom_Bailleur = 'NOM_BAILLEUR'
}
